import config from './config.js';

const getLogoUrl = (appName, assetRoot) => {
  const urlConfig = config(assetRoot);
  return urlConfig[appName] || urlConfig.default;
};

const addSublogo = (imgEl, appName, assetRoot) => {
  imgEl.src = getLogoUrl(appName, assetRoot);
  imgEl.classList.add('Header-appLogo--isVisible');
};

export default addSublogo;
